import { forwardRef, useImperativeHandle, useState } from "react"
import QRCode from "react-qr-code"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

import { DeviceTypes, DownloadLinkMap } from "@fuse/utils/DeviceDection"

import appStoreDownload from "@fuse/assets/images/People/img-app-store-download.svg"
import googlePlayDownload from "@fuse/assets/images/People/img-google-play-download.svg"

export interface DownloadAppModalHandle {
  openModal: () => void
  closeModal: () => void
}

const DownloadAppModalV4 = forwardRef<
  DownloadAppModalHandle,
  { showOnTop: boolean }
>(({ showOnTop = false }, ref) => {
  const [isVisible, setIsVisible] = useState(false)

  // Expose methods to parent via ref
  useImperativeHandle(ref, () => ({
    openModal: () => {
      setIsVisible(true)
    },
    closeModal: () => {
      setIsVisible(false)
    },
  }))

  if (!isVisible) return null

  const handleButtonClick = (url: string) => {
    window.open(url, "_blank")
  }

  const top =
    "fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[100] pt-40 items-start"
  const bottom =
    "fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[100] items-end md:items-center place-items-center"

  return (
    <div
      className={showOnTop ? top : bottom}
      onClick={() => setIsVisible(false)}
    >
      <BlurWrapper
        overlayOpacityDefault="20"
        className="w-full md:max-w-sm !bg-gray-500/10 rounded-t-2xl md:rounded-2xl p-6 relative flex flex-col cursor-auto place-content-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center justify-center gap-5 py-4">
          <p className="text-white text-lg font-medium">Download Let’s Hang!</p>
          <QRCode
            style={{ height: "auto" }}
            className="min-w-28 max-w-[8vw] aspect-square"
            value={`${window.location.origin}/downloadApp`}
            bgColor="transparent"
            fgColor="#FFFFFF"
            viewBox={`0 0 256 256`}
          />
          <p className="text-white/35">
            Scan this QR code with your phone to download the Let’s Hang! app
          </p>

          <div className="flex flex-row gap-5">
            <img
              src={appStoreDownload}
              alt="App Store"
              onClick={() =>
                handleButtonClick(DownloadLinkMap[DeviceTypes.IOS])
              }
            />
            <img
              src={googlePlayDownload}
              alt="Google Play"
              onClick={() =>
                handleButtonClick(DownloadLinkMap[DeviceTypes.ANDROID])
              }
            />
          </div>
        </div>
      </BlurWrapper>
    </div>
  )
})

export default DownloadAppModalV4
